import React, { useEffect, useRef, useState } from 'react';
import * as signalR from "@microsoft/signalr";
import axios from "axios";
import './WaterLeakage.css';
import click from './sounds/shortclick.mp3';
import icon from './images/icons8-place-marker-48.png';
import groundFloor from './images/FuTipMap_720px.png';

// Constants
const FLOOR_WIDTH = 730;

export default function WaterLeakage() {
    const [dev, setDev] = useState([]);
    const [waterleakdev, setWaterleakdev] = useState([]);
    const [busbarleakdev, setBusbarleakdev] = useState([]);
    const [capleakdev, setCapleakdev] = useState([]);
    const [carparkleakdev, setCarparkleakdev] = useState([]);
    const [retry, setRetry] = useState(false);
    const [hoveredDeviceId, setHoveredDeviceId] = useState(null);
    const [selectedChannel, setSelectedChannel] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const isInitialLoad = useRef(true);
    const [pins_g, setPins_g] = useState([]);

    // SignalR connection
    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/devicehub")
        .build();

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => { }
    };

    const handleCellEnter = (deviceId) => {
        setHoveredDeviceId(deviceId);
        playClickSound();
    };

    const handleCellLeave = () => {
        setHoveredDeviceId(null);
    };

    const FloorplanImage = ({ src, alt }) => (
        <div className="estate-image" align-items="center">
            <img src={src} alt={alt} width={FLOOR_WIDTH} />
        </div>
    );

    const PinIcon = ({ id, x, y, isHovered }) => {
        return (
            <div style={{
                position: "absolute",
                left: `${x}px`,
                top: `${y}px`,
                transform: "translate(-50%, -50%)",
                zIndex: 5,
                cursor: "pointer"
            }}
                onMouseEnter={() => handleCellEnter(id)}
                onMouseLeave={handleCellLeave}
            >
                {isHovered && (
                    <div style={{
                        position: "absolute",
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(255, 215, 0, 0.3)",
                        border: "2px solid rgba(255, 215, 0, 0.8)",
                        animation: "pulse 1.5s infinite",
                        transform: "translate(-50%, -50%)",
                    }} />
                )}

                <div style={{
                    position: "absolute",
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: isHovered ? "yellow" : "red",
                    transform: "translate(-50%, -50%)",
                    transition: "all 0.3s ease",
                    boxShadow: isHovered ? "0 0 10px gold" : "none"
                }} />
            </div>
        );
    };

    const ImageWithPins = ({ pins, hoveredDeviceId }) => (
        <div>
            {pins.map((pin) => (
                <PinIcon
                    key={pin.id}
                    id={pin.id}
                    x={pin.x}
                    y={pin.y}
                    isHovered={hoveredDeviceId === pin.id}
                />
            ))}
        </div>
    );

    const DeviceCell = ({ device, isHovered }) => {
        const cellStyle = {
            fontSize: "16px",
            overflow: "hidden",
            color: "#f7f4ef",
            backgroundColor: isHovered ? "#1a237e" : "#525252",
            transition: "all 0.3s ease",
            borderRadius: "4px",
            padding: "8px",
            margin: "4px",
            // Add shadow and transform effects
            boxShadow: isHovered
                ? "0 15px 30px rgba(0,0,0,0.6), 0 10px 10px rgba(0,0,0,0.4)"
                : "0 8px 16px rgba(0,0,0,0.4), 0 4px 8px rgba(0,0,0,0.3)",
            transform: isHovered
                ? "translateY(-10px) scale(1.05)"
                : "translateY(-3px) scale(1.01)",
            zIndex: isHovered ? 20 : 5,
            position: "relative"
        };

        return (
            <td
                key={device.id}
                className="waterleakcellstyle"
                style={cellStyle}
                onMouseEnter={() => handleCellEnter(device.id)}
                onMouseLeave={handleCellLeave}
            >
                <table>
                    <tbody>
                        <tr style={{ fontSize: "22px", fontWeight: "bold", height: "78px" }}>{device.label}</tr>
                        <tr>
                            <div style={{
                                fontSize: "24px",
                                overflow: "hidden",
                                fontWeight: "bold",
                                color: isHovered ? "gold" : (device.type === 1 ? "#ff5252" : "#4caf50")
                            }}>
                                <div
                                    className="waterleakstatusstyle"
                                    style={{
                                        marginTop: "auto",
                                        textAlign: "center",
                                        fontSize: "26px",
                                        fontWeight: "bold",
                                        color: "#f5f0e9",
                                        backgroundColor: device.type === 1 ? "#d32f2f" : "#1976d2",
                                        borderRadius: "4px",
                                        padding: "4px",
                                        boxShadow: isHovered ? "0 0 8px rgba(255,215,0,0.7)" : "none"
                                    }}
                                >
                                    {device.status}
                                </div>
                            </div>
                        </tr>
                    </tbody>
                </table>
            </td>
        );
    };

    function DeviceList() {
        return (
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '4px' }}>
                <tbody>
                    <tr>
                        <td colSpan="2" style={{ verticalAlign: 'top' }}>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '4px',
                                backgroundColor: '#888888',
                                borderRadius: '12px',
                                padding: '4px',
                                margin: '4px 0'
                            }}>
                                <h3 style={{
                                    width: '100%',
                                    padding: '8px',
                                    margin: 0,
                                    color: '#ffffff',
                                    fontSize: '28px',
                                    fontWeight: '600',
                                    backgroundColor: '#ff7f27',
                                    borderRadius: '8px'
                                }}>斑蝶樓</h3>
                                <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '4px',
                                    width: '100%'
                                }}>
                                    {Array.isArray(waterleakdev) &&
                                        waterleakdev
                                            .map((device) => (
                                                <DeviceCell
                                                    key={device.id}
                                                    device={device}
                                                    isHovered={hoveredDeviceId === device.id}
                                                />
                                            ))
                                    }
                                </div>
                                <h3 style={{
                                    width: '100%',
                                    padding: '8px',
                                    margin: 0,
                                    color: '#ffffff',
                                    fontSize: '28px',
                                    fontWeight: '600',
                                    backgroundColor: '#f411f4',
                                    borderRadius: '8px'
                                }}>制櫃頂水濕</h3>
                                <div style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: '4px',
                                    width: '100%'
                                }}>
                                    {Array.isArray(busbarleakdev) &&
                                        busbarleakdev
                                            .map((device) => (
                                                <DeviceCell
                                                    key={device.id}
                                                    device={device}
                                                    isHovered={hoveredDeviceId === device.id}
                                                />
                                            ))
                                    }
                                </div>

                                {/* Two sections side by side */}
                                <div style={{ width: 'calc(50% - 2px)', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <h3 style={{
                                        width: '100%',
                                        padding: '8px',
                                        margin: 0,
                                        color: '#ffffff',
                                        fontSize: '28px',
                                        fontWeight: '600',
                                        backgroundColor: '#037c03',
                                        borderRadius: '8px'
                                    }}>停車場水浸</h3>
                                    <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: '4px',
                                    }}>
                                        {Array.isArray(carparkleakdev) &&
                                            carparkleakdev
                                                .map((device) => (
                                                    <DeviceCell
                                                        key={device.id}
                                                        device={device}
                                                        isHovered={hoveredDeviceId === device.id}
                                                    />
                                                ))
                                        }
                                    </div>
                                </div>

                                <div style={{ width: 'calc(50% - 2px)', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <h3 style={{
                                        width: '100%',
                                        padding: '8px',
                                        margin: 0,
                                        color: '#ffffff',
                                        fontSize: '28px',
                                        fontWeight: '600',
                                        backgroundColor: '#7411f4',
                                        borderRadius: '8px'
                                    }}>珍蝶樓</h3>
                                    <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: '4px',
                                    }}>
                                        {Array.isArray(capleakdev) &&
                                            capleakdev
                                                .map((device) => (
                                                    <DeviceCell
                                                        key={device.id}
                                                        device={device}
                                                        isHovered={hoveredDeviceId === device.id}
                                                    />
                                                ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }

    useEffect(() => {
        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net', 
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    mapx: item.mapx === null ? null : item.mapx * FLOOR_WIDTH / 720,
                    mapy: item.mapy === null ? null : item.mapy * FLOOR_WIDTH / 720,
                    type: item.type,
                    buildingId: item.buildingId,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    active: item.active,
                    unit: item.unit
                }));

                const scaledPin_2 = deviceDetails
                    .filter(device => device.data_type === 6 || device.data_type === 7 || device.data_type === 22 )
                    .filter(d => d.active === 1)
                    .filter(device => device.mapx !== null && device.mapy !== null)
                    .map(device => ({ ...device, x: device.mapx, y: device.mapy }));

                setPins_g(scaledPin_2);
                setDev(deviceDetails);

                const filteredDev = deviceDetails
                    .filter(d => d.data_type === 6)
                    .filter(d => d.active === 1);
                setWaterleakdev(filteredDev);

                const busbarfilteredDev = deviceDetails
                    .filter(d => d.data_type === 7)
                    .filter(d => d.active === 1);
                setBusbarleakdev(busbarfilteredDev);

                const carfilteredDev = deviceDetails
                    .filter(d => d.data_type === 22)
                    .filter(d => d.active === 1);
                setCarparkleakdev(carfilteredDev);

                const capfilteredDev = deviceDetails
                    .filter(d => d.data_type === 31)
                    .filter(d => d.active === 1);
                setCapleakdev(capfilteredDev);

                setIsLoading(false);
            } catch (error) {
                console.error(error);
                setRetry(true);
            }
        };

        getData();
    }, [retry]);

    useEffect(() => {
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net', 
            headers: { 'Content-Type': 'application/json' }
        });

        const getData = async () => {
            try {
                const response = await httpClient.get('/api/meters');
                const deviceDetails = response.data.map((item) => ({
                    id: item.deviceId,
                    deviceName: item.deviceName,
                    deviceEui: item.deviceEui,
                    label: item.label,
                    status: item.status,
                    mapx: item.mapx === null ? null : item.mapx * FLOOR_WIDTH / 720,
                    mapy: item.mapy === null ? null : item.mapy * FLOOR_WIDTH / 720,
                    type: item.type,
                    buildingId: item.buildingId,
                    data_type: item.dataType,
                    alive: item.alive,
                    data: item.data,
                    channel: item.channel,
                    active: item.active
                }));

                const scaledPin_2 = deviceDetails
                    .filter(device => device.data_type === 6 || device.data_type === 7 || device.data_type === 22 )
                    .filter(d => d.active === 1)
                    .filter(device => device.mapx !== null && device.mapy !== null)
                    .map(device => ({ ...device, x: device.mapx, y: device.mapy }));

                setPins_g(scaledPin_2);
                setDev(deviceDetails);

                const filteredDev = deviceDetails
                    .filter(d => d.data_type === 6)
                    .filter(d => d.active === 1);
                setWaterleakdev(filteredDev);

                const busbarfilteredDev = deviceDetails
                    .filter(d => d.data_type === 7)
                    .filter(d => d.active === 1);
                setBusbarleakdev(busbarfilteredDev);

                const carfilteredDev = deviceDetails
                    .filter(d => d.data_type === 22)
                    .filter(d => d.active === 1);
                setCarparkleakdev(carfilteredDev);

                const capfilteredDev = deviceDetails
                    .filter(d => d.data_type === 31)
                    .filter(d => d.active === 1);
                setCapleakdev(capfilteredDev);

                if (isInitialLoad.current) {
                    isInitialLoad.current = false;
                }
            } catch (error) {
                console.error(error);
            }
        };

        connection
            .start()
            .then(() => console.log("Connected to the hub"))
            .catch((err) => console.error(err));

        connection.on("ReceiveDeviceData", () => {
            console.log("Updating....");
            getData();
        });

        return () => {
            connection.off("ReceiveDeviceData");
        };
    }, []);

    return (
        <div className="containerstyle">
            <table>
                <tbody>
                    <tr>
                        <td style={{ verticalAlign: "top", width: "760px" }}>
                            <table style={{ verticalAlign: "top" }}>
                                <tbody>
                                    <tr>
                                        {!isLoading && (
                                            <div className="floorpin">
                                                <FloorplanImage src={groundFloor} alt="Ground Floor" />
                                                <ImageWithPins pins={pins_g} hoveredDeviceId={hoveredDeviceId} />
                                            </div>
                                        )}
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                            <table style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1000px" }}>
                                <tbody>
                                    <DeviceList />
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}